import React from "react";
import styled from "styled-components";
import { Textarea } from "components/ui/textarea";

export default function QuestionText({ question, currentAnswer, onAnswerChange, hideInput = false }) {
  return (
    <div style={{ marginTop: "1rem" }}>
      <Question>{question.question}</Question>
      <br />
      {!hideInput && (
        <Textarea
          value={currentAnswer?.response}
          placeholder="Type your answer here..."
          onChange={(e) => onAnswerChange(question.uniqueId, { response: e.target.value })}
          style={{
            width: "100%",
            marginTop: "8px",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ddd",
            fontFamily: "Raleway, sans-serif",
            backgroundColor: "#fff",
            minHeight: "100px",
            resize: "vertical"
          }}
        />
      )}
    </div>
  );
}



const Question = styled.div`
    font-size: 18px;
    font-weight: 600;
    color:#2A3039;
    margin-bottom: 0px;
`

